module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "labelAutocomplete"
    }
  }, [_c('ul', {
    staticClass: "list-group",
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "z-index": "999"
    }
  }, _vm._l((_vm.filteredLabels), function(label, index) {
    return _c('li', {
      key: index,
      staticClass: "list-group-item"
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.$emit('selected', label)
        }
      }
    }, [_vm._v(_vm._s(label))])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0297b7b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plugins/LabelAutocomplete.vue
// module id = 1276
// module chunks = 0